// extracted by mini-css-extract-plugin
export default {"wrapper":"Ss5uYom","actions":"LPwiIB_"};